__webpack_require__.p = "/cozycabincafe/";